<script lang="ts" context="module">
    
    import type { User } from "../Model/User";

    const usersCache = new Map<string, Promise<User>>();

</script>

<script lang="ts">
    import { usersService } from "../services";

    export let userId: string;

    let userName = '';

    $: getUserName(userId);

    async function getUserName(userId: string): Promise<void> {
        try {
            if (!usersCache.has(userId)) {
                usersCache.set(userId, usersService.findOne(userId));
            }
            const user = await usersCache.get(userId)!;
            userName = user.name;
        } catch (error) {
            console.error(error);
        }
    }

</script>

{userName}